import labels from './labels';

export default {
  settings: {
    languageId: 'en-US',
    currencyId: 'USD',
  },
  components: {},
  labels,
};
